import type { BranchState } from './branchState'
import { tally } from './bookings'
import { pastTarget } from './callingWait'
import { homeFigures } from './homeTiles'
import { deskAvailability } from './receptionDesk'
import type { Appointment } from './types'

/** The figures across the top of Reception. */
export interface ReceptionKpis {
  waiting: number
  longestSec: number
  /** Desks not closed: serving, free or on a break, as the Desks panel counts them. */
  desksOpen: number
  /** Waiting tickets at or past their queue's target. */
  overTarget: number
  /** Today's bookings still to arrive. */
  bookingsDue: number
}

/** Reception's figures, from the live branch state and today's bookings. */
export function receptionKpis(state: BranchState | null, bookings: readonly Appointment[], now: number): ReceptionKpis {
  const { waiting, longestSec } = homeFigures(state, [], '', now)
  return {
    waiting,
    longestSec,
    desksOpen: (state?.counters ?? []).filter((d) => deskAvailability(d) !== 'closed').length,
    overTarget: pastTarget((state?.tickets ?? []).filter((t) => t.state === 'waiting'), now),
    bookingsDue: tally(bookings).booked,
  }
}
